import React from 'react';
import { Control, FormState, FieldValues } from 'react-hook-form';
import {
	CheckboxLayoutItem,
	RadioButtonLayoutItem,
	SelectLayoutItem,
	TextFieldLayoutItem,
} from 'models/InputLayoutItem';
import { InputLayout } from 'components/create-form/form-items/InputLayout';
import { RadioButtonLayout } from 'components/create-form/form-items/RadioButtonLayout';
import { SelectLayout } from 'components/create-form/form-items/SelectLayout';
import { CheckboxLayout } from 'components/create-form/form-items/CheckboxLayout';
import { LAYOUT_ITEM } from 'constants/FormConstants';
import { InputFileUpload } from './form-items/InputFileUpload';
import { ConsentBoxLayout } from './form-items/ConsentBoxLayout';

interface FormLayoutProps {
	field: TextFieldLayoutItem | RadioButtonLayoutItem | SelectLayoutItem | CheckboxLayoutItem;
	control: Control<FieldValues>;
	formState: FormState<FieldValues>;
	handleChange?: any;
}

export const FormLayout = ({ field, control, formState, handleChange }: FormLayoutProps) => {
	return (
		<>
			{
				{
					[LAYOUT_ITEM.TYPE.INPUT]: (
						<InputLayout
							key={field.label}
							{...(field as TextFieldLayoutItem)}
							control={control}
							errors={formState.errors}
						/>
					),
					[LAYOUT_ITEM.TYPE.RADIO_BUTTON]: (
						<RadioButtonLayout
							key={field.label}
							{...(field as RadioButtonLayoutItem)}
							control={control}
							handleChange={(e) => handleChange(e, field.name, field.type)}
						/>
					),
					[LAYOUT_ITEM.TYPE.SELECT]: (
						<SelectLayout
							key={field.label}
							{...(field as SelectLayoutItem)}
							control={control}
							errors={formState.errors}
							handleChange={(e) => handleChange(e, field.name, field.type)}
						/>
					),
					[LAYOUT_ITEM.TYPE.CHECKBOX]: (
						<CheckboxLayout
							key={field.label}
							{...(field as CheckboxLayoutItem)}
							control={control}
							handleChange={(e) => handleChange(e, field.name, field.type)}
						/>
					),
					[LAYOUT_ITEM.TYPE.FILE]: (
						<InputFileUpload
							label={field.label}
							name={field.name}
							accept=".jpg,.pdf"
							tooltip="Upload your document here"
							control={control}
							errors={formState.errors}
							maxSize={5 * 1024 * 1024} // 5MB
						/>
					),
					[LAYOUT_ITEM.TYPE.CONSENT_CHECKBOX]: (
						<ConsentBoxLayout
							key={field.name}
							name={field.name}
							control={control}
							defaultValue={field.defaultValue}
						/>
					),
				}[field.type]
			}
			{field.dropText ? <>{field.dropText}</> : null}
		</>
	);
};
